/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Sales_ChannelInputs */

const vi_customer_sales_channel = /** @type {(inputs: Customer_Sales_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kênh bán hàng`)
};

/**

* @param {Customer_Sales_ChannelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_sales_channel = /** @type {((inputs?: Customer_Sales_ChannelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Sales_ChannelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_sales_channel(inputs)
});